import React from "react";
import GrupoProdutos from "./components/GrupoProdutos";
import MockData from "./model/MockData";
import ProdutoModel from "./model/ProdutoModel";
import RodapeProdutoContexto from "./components/RodapeProdutoContexto";
import RodapeProduto from "./components/RodapeProduto";
import ProdutoDescricao from "./components/ProdutoDescricao";
import QueryString from "query-string";
import ProdutoDescricaoModel from "./model/ProdutoDescricaoModel";
import SeletorLoja from "./components/SeletorLoja";
import AppState from "./model/AppState";
import ConteudoModel from "./model/ConteudoModel";
import GrupoConteudos from "./components/GrupoConteudos";
import PaginaTitulo from "./components/PaginaTitulo";
import CarrinhoItemModel from "./model/CarrinhoItemModel";
import ModalObservacoes from "./components/ModalObservacoes";
import C5ProdutoDAO from "./dataAccess/C5/C5ProdutoDAO";
import CarrinhoModel from "./model/CarrinhoModel";
import WPBuscaDAO from "./dataAccess/WP/WPBuscaDAO";
import LojaModel from "./model/LojaModel";
import ObaInfoNutricionalDAO from "./dataAccess/Oba/ObaInfoNutricionalDAO";
import NavegadorUtil from "./util/NavegadorUtil";
import LogUtil from "./util/LogUtil";
import C5CategoriaDAO from "./dataAccess/C5/C5CategoriaDAO";
import Carregando from "./components/Carregando";

import { ReactComponent as ImagemBemQuerer } from "./assets/images/icons/ico_bq.svg";
import Rodape from "./components/Rodape";
import { RouteComponentProps } from "react-router-dom";

interface IProdutoProps extends RouteComponentProps {}

type ProdutoState = {
  showModalObservacoes: boolean;
  observacao: string;
  produto: ProdutoModel | null;
  produtos: ProdutoModel[];
  similares: ProdutoModel[];
  conteudos: ConteudoModel[];
  infoNutricional?: ProdutoDescricaoModel;
  carregando: boolean;
  concluido: boolean;
  carregandoIcone: boolean;
  selos: any[];
};

class Produto extends React.Component<IProdutoProps, ProdutoState> {
  constructor(props: IProdutoProps) {
    super(props);
    this.saveObservacoes = this.saveObservacoes.bind(this);
    this.toggleModalObservacoes = this.toggleModalObservacoes.bind(this);
    this.state = {
      showModalObservacoes: false,
      observacao: "",
      produto: null,
      produtos: [],
      conteudos: [],
      selos: [],
      similares: [],
      carregando: true,
      concluido: false,
      carregandoIcone: false,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Produto");

    this.carregaProduto();
  }

  carregaProduto(): void {
    let query: any;
    query = QueryString.parse(this.props.location.search);

    if (AppState.getMockData()) {
      this.setState({
        produto: MockData.getProduto(query.prodId),
        produtos: MockData.getProdutos(),
        conteudos: MockData.getConteudos(),
      });
    } else {
      const loja: LojaModel | null = AppState.getLojaSelecionada();
      if (loja) {
        const allProms: any = [];

        C5ProdutoDAO.getInstance()
          .getById(query.prodId, loja.lojaId)
          .then((prod: ProdutoModel | null) => {
            if (prod) {
              let selos: any = AppState.getSelos(+prod.produtoId);

              if (!selos) {
                selos = [];
              }

              this.setState({
                produto: prod,
                carregando: false,
                carregandoIcone: true,
                selos
              });
              if (prod.sku) {
                WPBuscaDAO.getInstance()
                  .getBySKU(prod.sku, false)
                  .then((conteudos: ConteudoModel[]) => {
                    this.setState({ conteudos });
                  });
                allProms.push(
                  ObaInfoNutricionalDAO.getInstance()
                    .getByIdProdutoEstadoLoja(prod.sku, loja)
                    .then((infoNutricional: ProdutoDescricaoModel) => {
                      if (
                        infoNutricional.descricao.indexOf("porção de 0g") === -1
                      ) {
                        this.setState({ infoNutricional });
                      }
                    })
                );
                allProms.push(
                  C5CategoriaDAO.getInstance()
                    .getTerceiroNivelProdutos(
                      prod.categoriaId.toString(),
                      prod.subcategoriaId.toString(),
                      prod.subsubcategoriaId.toString(),
                      loja.lojaId
                    )
                    .then((prods: ProdutoModel[]) => {
                      this.setState({
                        similares: prods.filter(
                          (p) => p.produtoId !== prod.produtoId
                        ),
                      });
                    })
                );

                let query: any;
                query = QueryString.parse(this.props.location.search);
                const carrinho: CarrinhoModel = AppState.getCarrinho();
                const carrinhoItem:
                  | CarrinhoItemModel
                  | undefined = carrinho.carrinhoItens.find(
                  (ci) =>
                    ci.produto.produtoId.toString() === query.prodId.toString()
                );
                if (carrinhoItem) {
                  this.setState({ observacao: carrinhoItem.notas });
                }
                Promise.all(allProms)
                  .then(() => {
                    this.setState({ carregandoIcone: false, concluido: true });
                  })
                  .catch((ex) => {
                    LogUtil.log("Erro ao carregar algum recurso externo");
                    LogUtil.logObject(ex, typeof ex);
                    this.setState({ carregandoIcone: false, concluido: true });
                  });
              }
            }
          }).catch((err) => {
            LogUtil.logObject(err, typeof err);
            this.setState({ carregando: false });
            LogUtil.logEvento('ErroCarregarProduto', err);
            NavegadorUtil.alerta(this, `Erro ao carregar produto`);
          });
      } else {
        NavegadorUtil.redirect("/lojas", this.props.history);
      }
    }
  }

  componentDidUpdate(prevProps: IProdutoProps, prevState: ProdutoState): void {
    window.scrollTo(0, 0);
    let query: any;
    query = QueryString.parse(this.props.location.search);
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    const carrinhoItem:
      | CarrinhoItemModel
      | undefined = carrinho.carrinhoItens.find(
      (ci) => ci.produto.produtoId === query.prodId
    );
    if (carrinhoItem) {
      if (prevState.observacao !== carrinhoItem.notas) {
        this.setState({ observacao: carrinhoItem.notas });
      }
    }
  }

  saveObservacoes(obs: string): void {
    let query: any;
    query = QueryString.parse(this.props.location.search);
    AppState.setCarrinhoItemNota(query.prodId, obs);

    this.setState({ observacao: obs });

    NavegadorUtil.alerta(this, "Observação salva com sucesso!");
    this.toggleModalObservacoes();
  }

  toggleModalObservacoes(): void {
    this.setState({ showModalObservacoes: !this.state.showModalObservacoes });
  }

  handleClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
  };

  render(): any {
    const {
      produto,
      conteudos,
      similares,
      infoNutricional,
      carregando,
      carregandoIcone,
      selos,
      concluido
    } = this.state;

    if (carregando) {
      return (
        <section className="product white-bg">
          <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
          <PaginaTitulo titulo={"Carregando ..."}></PaginaTitulo>
          <Carregando exibir={carregando} concluido={concluido}></Carregando>
        </section>
      );
    }

    let query: any;

    query = QueryString.parse(this.props.location.search);

    if (produto && query.prodId && +query.prodId !== +produto.produtoId) {
      this.carregaProduto();
    }

    let fm: number = 1;
    if (query.fm) {
      fm = +query.fm;
      if (produto) {
        produto.fatorMultiplicacao = fm;
      }
    }

    let prodPrecoOriginal: number = 0;
    let prodPrecoDesconto: number = 0;

    if (produto) {
      prodPrecoOriginal = produto.precoOriginal;
      prodPrecoDesconto = produto.precoDesconto;

      if (produto.unidade === "GR") {
        prodPrecoOriginal =
          (produto.precoOriginal / 1000) * produto.fatorMultiplicacao;
        prodPrecoDesconto =
          (produto.precoDesconto / 1000) * produto.fatorMultiplicacao;
      }
    }

    let isProdutoBemQuerer: boolean = false;
    const prodsBQ: ProdutoModel[] | null = AppState.getProdutoBemQuerer();
    if (prodsBQ && produto) {
      const prodBQ: ProdutoModel | undefined = prodsBQ.find(
        (p) => p.produtoId === produto.produtoId
      );
      if (prodBQ) {
        isProdutoBemQuerer = true;
      }
    }

    let linkCategoria: string = NavegadorUtil.getUrl(`categoria?catId=${produto?.categoriaId}&nome=${produto?.categoria}`);

    return (
      <section className="product white-bg">
        <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
        {produto && (
          <>
            <PaginaTitulo 
              titulo={ProdutoModel.getNome(produto)} 
              subtitulo={`Ver mais produtos (${produto.categoria})`}
              subtituloClick={ () => this.props.history.push(linkCategoria) }></PaginaTitulo>
            <div className="item">
              {isProdutoBemQuerer && (
                <div className="bemQuerer">
                  <ImagemBemQuerer />
                </div>
              )}
              <div className="photo">
                <img
                  src={produto.imagem}
                  title={ProdutoModel.getNome(produto)}
                  alt={ProdutoModel.getNome(produto)}
                />
              </div>

              {produto.precoDesconto > 0 &&
                produto.precoDesconto < produto.precoOriginal && (
                  <div className="prices-discount">
                    <div className="values">
                      <p className="original">{`R$ ${prodPrecoOriginal
                        .toFixed(2)
                        .replace(".", ",")}`}</p>
                      <p className="current">
                        {`R$ ${prodPrecoDesconto.toFixed(2).replace(".", ",")}`}
                        <span>{ProdutoModel.getGR(produto)}</span>
                      </p>
                      <p className="perKg">
                        {produto.unidade === "GR" && (
                          <>
                            R$
                            {produto.precoDesconto.toFixed(2).replace(".", ",")}
                            /Kg
                          </>
                        )}
                      </p>
                    </div>
                    <div className="discount">
                      {`-${(
                        100 -
                        (produto.precoDesconto / produto.precoOriginal) * 100
                      ).toFixed(0)}%`}
                    </div>
                  </div>
                )}

              {!(
                produto.precoDesconto > 0 &&
                produto.precoDesconto < produto.precoOriginal
              ) && (
                <>
                  <div className="prices-regular">
                    <p className="current">
                      {`R$ ${prodPrecoOriginal.toFixed(2).replace(".", ",")}`}
                      <span> {ProdutoModel.getGR(produto)}</span>
                    </p>
                    <p className="perKg">
                      &nbsp;
                      {produto.unidade === "GR" && (
                        <>
                          R$
                          {produto.precoDesconto.toFixed(2).replace(".", ",")}
                          /Kg
                        </>
                      )}
                    </p>
                  </div>
                </>
              )}
            </div>
            <button onClick={this.toggleModalObservacoes} className="obs">
              <i className="fas fa-pencil-alt"></i> Observações
            </button>
            <ul className="seals">
              { selos.map((selo: any) => (
                <li><img src={selo.url} alt="Selo de produto" /></li>
              ))}
            </ul>
            {/* produto.descricoes && produto.descricoes.length > 0 && produto.descricoes.map((desc: ProdutoDescricaoModel) =>
          <ProdutoDescricao titulo={desc.titulo} descricao={desc.descricao} key={ desc.descricaoId } ></ProdutoDescricao>
        )*/}
            {infoNutricional && (
              <ProdutoDescricao
                titulo={infoNutricional.titulo}
                descricao={infoNutricional.descricao}
                key={infoNutricional.descricaoId}
              />
            )}
            <GrupoProdutos
              titulo="Produtos similares"
              items={similares}
              parent={this}
            ></GrupoProdutos>
            <GrupoConteudos
              titulo="Inspire-se"
              items={conteudos}
              parent={this}
            ></GrupoConteudos>
            <ModalObservacoes
              observacao={this.state.observacao}
              visivel={this.state.showModalObservacoes}
              save={this.saveObservacoes}
              hide={this.toggleModalObservacoes}
            ></ModalObservacoes>
            <RodapeProdutoContexto
              produto={produto}
              parent={this}
            ></RodapeProdutoContexto>
            <RodapeProduto
              observacao={this.state.observacao}
              produto={produto}
              parent={this}
              fm={fm}
            ></RodapeProduto>
          </>
        )}
        <Carregando exibir={carregandoIcone} concluido={concluido} />
        <Rodape parent={this} ativo="Produto"></Rodape>
      </section>
    );
  }
}

export default Produto;
